'use strict';

import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';
import config from '../../../js/config';
import mediator from '../../../js/mediator';
import $global from '../../../js/globalElements';
import ShowHide from '../../../js/components/ShowHide';
import utilities from '../../../js/utilities';
import Analytics from '../../Analytics/Analytics';

const NO_AUTO_SEARCH_BODY_CLASSES = [
  config.classes.isEditorMode,
  config.classes.hasHeaderDropdown,
  config.classes.remodalIsActive,
  config.classes.hasmegaMenuOpen,
  config.classes.isMinimisedHeader
]
  .map((className) => '.' + className)
  .join(',');

var SearchBarView = Backbone.View.extend({
  events: {
    'keyup .js-search-input': 'inputEvents',
    'change .cat': 'inputEvents',
    'blur .js-search-input': 'setPlaceholderText',
    'click .Search-placeholder': 'clickedPlaceholderText',
    'focus .js-search-input': 'tabbedToPlaceholderText'
  },

  initialize: function() {
    this.defaultVal = this.$el.find('.js-search-input').val() || '';
    this.$productSearchForm = this.$el.find('.product-search-bar-form');
    this.$searchBar = this.$el.find('.Search-bar');
    this.$searchBarInput = this.$el.find('.js-search-input');
    this.typeaheadClass = 'Header-search-typeaheadOpen';
    this.$searchInput = this.$el.find('.Search-bar').children('.js-search-input');
    this.$searchPlaceholder = this.$el.find('.Search-placeholder');
    this.$searchDropdown = this.$el.find('.Header-search-minimisedHeader');
    this.$minimisedHeaderCta = this.$searchDropdown.find('.Header-search-minimisedHeader--cta.Icon--mag-glass');
    this.$searchInStockCheckbox = this.$el.find('.Search-in-stock-checkbox');
    this.$searchInStockStyledCheckbox = this.$el.find('.Search-in-stock-styled-checkbox');
    this.$selectFilter = $('.cat');
    this.$displaySelection = $('.viewport');

    mediator.on(config.events.search.typeaheadHighlightedQuery, this.setVisibleQuery, this);
    mediator.on(config.events.search.close, this.setVisibleQuery, this);

    this.chosenCategory = this.getCategoryFilter();
    if (this.chosenCategory !== undefined && this.chosenCategory !== null && this.chosenCategory !== 'undefined') {
      this.$selectFilter.val(this.chosenCategory);
      this.ellipsisSelect();
    }

    if (window.location.search === '' && window.location.pathname.indexOf('products') === -1) {
      this.$selectFilter.val('');
      this.ellipsisSelect();
    }

    let unfilteredSearchExecuted = this.getUnfilteredSearchExecuted();
    if (unfilteredSearchExecuted) {
      this.$selectFilter.val(this.$selectFilter.find('option:first').val());
      this.ellipsisSelect();
    }

    let that = this;
    this.$selectFilter.on('change', function() {
      that.ellipsisSelect();
      that.getCategoryValue();
      let chosenCategory = $(this).find('option:selected').val();

      let data = {
        'event': config.analytics.eventTypes.Click,
        'category': config.analytics.categoryTypes.Search,
        'action': config.analytics.actions.CategoryDropdown,
        'label': chosenCategory
      };

      Analytics.pushToEventFramework(data);
    });

    this.$searchInStockCheckbox.on('change', () => {
      this.setInStockFilter();
      this.attemptSearch();
    });

    this.ellipsisSelect();
    this.setPlaceholderText();
    this.onLoadSearch();
    this.recentSearchesEnabled = false;

    let params = utilities.deserialize(window.location.search);

    if (params.q) {
      this.removePlaceholderText();
      let isReferenceDesignsUrl = utilities.windowLocationContains(config.urls.referenceDesigns);
      let isArticlesAndVideosUrl = utilities.windowLocationContains(config.urls.articlesAndVideos);
      if (!(params.datasheets || isReferenceDesignsUrl || isArticlesAndVideosUrl)) {
        this.setVisibleQuery(params.q);
      }
    }

    //Execute code related to the checkbox only if it's visible
    if (this.isInStockFilterAvailable()) {
      //If "if" is in the url, it means the checkbox was checked when performing the search, so check it again.
      if (params) {
        if ((params.if && params.if.length) || (params['amp;if'] && params['amp;if'].length)) { //Added this check, URL comes through like this after clicking on category on search results
          this.$searchInStockCheckbox.prop('checked', true);
        }
      }
    }

    this.$productSearchForm.submit(() => {
      this.tryAddInStockFilter();
      this.tryAddSearchbarCategoryFlag();
      this.saveCategoryFilter();
    });

    if (params && params.q && params.r) {
      this.setRecentSearches(params.q);
    }

    new ShowHide({
      el: this.$el,
      type: this.$searchDropdown,
      activeBodyClass: config.classes.hasHeaderDropdown,
      activeClass: 'Header-search-minimisedHeader--open',
      group: 'Header',
      animation: 'slide',
      onShow: () => {
        let headerCtaDataAtributes = this.$minimisedHeaderCta.data();
        if (headerCtaDataAtributes) {
          let analyticsObject = Analytics._createAnalyticObject(headerCtaDataAtributes);
          Analytics.pushToEventFramework(analyticsObject);
        }
        this.handleMinimisedSearch();
      }
    });
  },
  ellipsisSelect: function() {
    let $selectFilter = $('.is-minimised-header').length ? $('.Header-search-searchBar--minimised').find('.cat') : $('.Header-search-searchBar--expanded').find('.cat');
    this.$displaySelection.text($selectFilter.find('option:selected').text());
  },
  setTopPositionTypeHead: function() {
    let $selectInput = $('.is-minimised-header').length ? $('.Header-search-searchBar--minimised').find('.js-search-input') : $('.Header-search-searchBar--expanded').find('.js-search-input');
    let top = $selectInput.offset().top + $selectInput.height() - $('.Main').offset().top;
    //When searchbar is in animation, correct height of minimised searchbar not present,so the height of the top should increase
    if ($selectInput.selector === '.Header-search-searchBar--minimised .js-search-input' && $('.Header-search-searchBar--minimised').height() < 35) {
      top = top + 23;
    }
    $('Section.Typeahead').css('top', Math.floor(top) + 3 + 'px');
    $('Section.Typeahead').css('transform', 'translateY(0px)');
    $('Section.Typeahead').find('.Typeahead-content-filter').css('top', '0px');
    $('Section.Typeahead').find('.TypeaheadAutocomplete').css('margin-top', '0px');
  },
  isInStockFilterAvailable: function() {
    return this.$searchInStockStyledCheckbox && this.$searchInStockStyledCheckbox.is(':visible');
  },

  // stopScollingEventOnFocus flag used to solve ARW-34718 Search Bar is disappearing when click on search button in footer
  handleMinimisedSearch() {
    config.analytics.flags.stopScollingEventOnFocus = true;
    this.$searchInput.focus();
    setTimeout(() => { config.analytics.flags.stopScollingEventOnFocus = false; }, 0);
  },

  onLoadSearch: function() {
    $global.$body.keydown((e) => {
      let inputCharacter = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (!this.shouldActivateAutoSearch(e, inputCharacter)) return;
      this.removePlaceholderText();
      this.$searchInput.focus();
    });
  },

  /**
   * We should only activate the search bar in particular circumstances.
   *
   * We are being as specific as possible so we don't get in the way of
   * the user's potential navigating of the page.
   *
   * @param keyboardEvent
   * @param inputCharacter
   * @returns {boolean}
   */
  shouldActivateAutoSearch: function(keyboardEvent, inputCharacter) {
    if (document.activeElement === this.$searchBarInput[0]) return false;
    if (keyboardEvent.which === config.key.tab) return false;
    if (!config.regex.alphaNumeric.test(inputCharacter)) return false;
    if (
      keyboardEvent.ctrlKey ||
      keyboardEvent.altKey ||
      keyboardEvent.shiftKey ||
      keyboardEvent.metaKey
    ) {
      return false;
    }
    let $activeElement = $(document.activeElement);
    if ($activeElement.is('[contenteditable]')) return false;
    if ($global.$body.is(NO_AUTO_SEARCH_BODY_CLASSES)) return false;
    return $activeElement.is('div,span,section,body');
  },

  removePlaceholderText: function() {
    this.$searchPlaceholder.addClass('is-hidden');
    config.analytics.flags.isPopupOn = true;
  },

  clickedPlaceholderText: function() {
    this.removePlaceholderText();
    this.$searchInput.focus();
  },

  tabbedToPlaceholderText: function(e) {
    this.removePlaceholderText();
    this.inputEvents(e);
  },

  setPlaceholderText: function() {
    for (var index = 0; index < this.$searchInput.length; index++) {
      if ((this.$searchBarInput.eq(index).val() === undefined || this.$searchBarInput.eq(index).val() === '') && !this.$searchInput.eq(index).is(':focus')) {
        this.$searchPlaceholder.eq(index).removeClass('is-hidden');
      } else {
        this.$searchPlaceholder.eq(index).addClass('is-hidden');
      }
    }
  },

  setInStockFilter: function() {
    let storedFilter = '';
    if (this.isInStockFilterAvailable() && this.$searchInStockCheckbox.prop('checked')) {
      storedFilter = config.events.search.stockFilterEnabled;
      utilities.localStorageSave(config.events.search.localStorageInstockFilter, JSON.stringify(storedFilter));
    } else {
      storedFilter = '';
      utilities.localStorageSave(config.events.search.localStorageInstockFilter, JSON.stringify(storedFilter));
    }
  },

  setRecentSearches: function(lastSearchItem) {
    if (lastSearchItem) {
      // Get local storage elements
      let storedElements = [];
      if (this.getRecentSearches()) {
        storedElements = this.getRecentSearches();
      }

      // Append the new element to front and remove duplicated
      storedElements.unshift({text: lastSearchItem.trim()});
      storedElements = _.uniq(storedElements, function(searchElement) { return searchElement.text; });

      // Set max amount of items stored
      if (storedElements.length > config.search.pastSearchListItems) {
        storedElements.length = config.search.pastSearchListItems;
      }

      // Store elements in local storage
      utilities.localStorageSave(config.events.search.localStorageTypeAhead, JSON.stringify(storedElements));
    }
  },

  getRecentSearches: function() {
    let stored = JSON.parse(utilities.localStorageLoad(config.events.search.localStorageTypeAhead));
    return stored;
  },
  getUnfilteredSearchExecuted: function() {
    let result = JSON.parse(utilities.sessionStorageLoad(config.events.search.unfilteredSearchExecuted));
    return result;
  },

  inputEvents: function(e) {
    config.analytics.flags.stopScollingEventOnFocus = true;
    setTimeout(() => { config.analytics.flags.stopScollingEventOnFocus = false; }, 0);
    this.getSearchValue();
    this.getCategoryValue();
    this.handleEvents(e);
  },
  getSearchValue: function() {
    this.searchValue = this.$searchInput.filter(':visible').val();
  },
  getCategoryValue: function() {
    this.categoryValue = this.$selectFilter.find('option:selected').val();
  },
  handleEvents: function(e) {

    switch (e.keyCode) {
      case config.key.escape:
        this.trigger(config.events.search.close);
        break;
      case config.key.left:
      case config.key.right:
        break;
      case config.key.up:
        if (this.getRecentSearches() && this.recentSearchesEnabled) {
          mediator.trigger(config.events.search.typeaheadChoosePreviousRecent);
        } else {
          mediator.trigger(config.events.search.typeaheadChoosePrevious);
        }
        break;
      case config.key.down:
        if (this.getRecentSearches() && this.recentSearchesEnabled) {
          mediator.trigger(config.events.search.typeaheadChooseNextRecent);
        } else {
          mediator.trigger(config.events.search.typeaheadChooseNext);
        }
        break;
      case config.key.backspace:
        ($(e.target).val() === '') ? this.trigger(config.events.search.closeAutoComplete) : this.attemptSearch();
        break;
      default:
        this.attemptSearch();
    }
  },
  //Include or exclude instock filter from search
  tryAddInStockFilter: function() {
    if (this.isInStockFilterAvailable() && this.$searchInStockCheckbox.prop('checked')) {
      this.$productSearchForm.append('<input type="hidden" name="filters" value="In Stock:Yes" />');
      this.$productSearchForm.append('<input type="hidden" name="if" value="y" />');
    }
  },

  //Include flag (category selected) that indicates the use of the category dropdown on the search bar, for google analytics
  tryAddSearchbarCategoryFlag: function() {
    if (this.$selectFilter && this.$selectFilter.val()) {
      this.$productSearchForm.append('<input type="hidden" name="cs" value="true" />');
    }
  },
  saveCategoryFilter: function() {
    this.getCategoryValue();
    utilities.localStorageSave(config.events.search.sessionStorageCategoryFilter, this.categoryValue);
  },
  getCategoryFilter: function() {
    return utilities.localStorageLoad(config.events.search.sessionStorageCategoryFilter);
  },
  attemptSearch: function() {
    this.setTopPositionTypeHead();
    if (this.searchValue && this.searchValue.length > 0) {
      this.removePlaceholderText();
    }
    if (this.lengthCheck()) {
      this.recentSearchesEnabled = false;
      this.setInStockFilter();
      this.trigger(config.events.search.makeSearch, this.searchValue, this.categoryValue);
    } else if (this.getRecentSearches()) {
      this.recentSearchesEnabled = true;
      this.setInStockFilter();
      this.trigger(config.events.search.makePastSearch, this);
      mediator.trigger(config.events.search.typeaheadDisplayRecentSearches, this);
    }
  },

  lengthCheck: function() {
    //Try getting the search term in case there was no 'keyup' event to get the value previously
    if (!this.searchValue) {
      this.getSearchValue();
    }
    return (this.searchValue.length >= config.search.autoCompleteCharacterTriggerLength);
  },

  onTypeaheadToggle: function() {
    this.$searchBar.toggleClass(this.typeaheadClass);
  },

  setVisibleQuery: function(q) {
    this.$searchInput.val(q);
  }

});

module.exports = SearchBarView;



// WEBPACK FOOTER //
// ./assets/components/Header/js/SearchBarView.js